const url = (path: string): string => {
  const urlPrefix = process.env.NEXT_PUBLIC_URL_PREFIX || '';
  return `${urlPrefix}${path}`;
};

export default url;
